<template>
	<div class="main" style="min-height:768px;">
		<section class="panel">
			<header class="panel-heading">
				<h2 class="panel-title">銷點申請</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">學&emsp;&emsp;號：</label>
						<div class="col-xs-9 col-md-7">{{model.account}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">學&emsp;&emsp;制：</label>
						<div class="col-xs-9 col-md-7">{{model.deptSsymStr}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">性&emsp;&emsp;別：</label>
						<div class="col-xs-9 col-md-7">{{model.sexStr}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">姓&emsp;&emsp;名：</label>
						<div class="col-xs-9 col-md-7">{{model.name}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">科系班級：</label>
						<div class="col-xs-9 col-md-7">
							<span v-if="model.deptCodeStr">{{model.deptCodeStr}}-{{model.drade}}年{{model.dradeClass}}班</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">宿&emsp;&emsp;舍：</label>
						<div class="col-xs-9 col-md-7">{{model.bedFloor}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">聯絡電話：</label>
						<div class="col-xs-9 col-md-7">{{model.tel}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">行動電話：</label>
						<div class="col-xs-9 col-md-7">{{model.phone}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">寢&emsp;&emsp;室：</label>
						<div class="col-xs-9 col-md-7">{{model.bedRoom}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">常用信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.extMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學校信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.schMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">床&emsp;&emsp;位：</label>
						<div class="col-xs-9 col-md-7">{{model.bed}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12">
						<label class="column-required">銷點原因說明:</label>
					</div>
					<div class="col-md-12" v-if="sessionData.accountType == 'STU' && model.revokeApply != 'Y'">
						<textarea  class="form-control" rows="5" name="revokeRecordRemark" v-model="model.revokeRecordRemark"  maxlength="400" v-validate="'required|max:400'"></textarea>
						<span class="text-danger" v-show="errors.has('revokeRecordRemark')">{{ errors.first('revokeRecordRemark') }}</span>
					</div>
					<div class="col-md-12" v-else>
						<p>{{model.revokeRecordRemark}}</p>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-offset-4 col-md-2">
						<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
					</div>
					<div class="col-md-2" v-if="model.revokeApply != 'Y'">
						<a href="javascript:;" class="btn btn-primary btn-block" @click="saveViolateRecord()">儲存</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	mounted(){
		if (this.getStore(this.$route.name)) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
			this.model.sno = this.storeData.sno;
			this.model.account = this.storeData.account;
			this.model.smtr = this.storeData.smtr;
			this.model.dormitoryType = this.storeData.dormitoryType;
			this.searchStu();
		}
	},
	data(){
		return{
			model:{},
			violateRecord:{},
			violateTypeList:[],
			awardTypeList:[],
		}
	},
	methods:{
		searchStu(){
			if(!this.model.account){
				bootbox.alert("請確認必填欄位是否有填寫");
				return false;
			}else{
				const api = "/api/Violate/searchStuData/";
				this.$axios.post(api, JSON.stringify(this.model)).then(resp =>{
					if(resp.data.status == "success"){
						this.model = resp.data.data;
					}else{
						bootbox.alert(resp.data.msg);
						this.$router.go(-1);
					}
				});
			}
		},
		saveViolateRecord(){
			let _this = this;
			this.$validator.validateAll().then(result =>{
				if(result){
					this.model.revokeApply = "Y";
					this.model.revokeName = "申請銷點中";
					const api = "/api/Violate/saveViolateRecord/";
					let data = {};
					for(var k in this.model){
						if(this.model[k]){
							if( ["revokeDate","crDate"].includes(k)){
								data[k] = this.customFormatter(this.model[k], "YYYY/MM/DD HH:mm:ss");
							}else{
								data[k] = this.model[k];
							}
						}
						
					}
					this.$axios.post(api, JSON.stringify(data)).then(resp => {
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.$router.go(-1);
							}
						});
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		clickPrevious() {
			this.$router.go(-1)
		},
		clearFunc(){
			let keepSessionData = this.sessionData;
			let keepStoreData = this.storeData;
			Object.assign(this.$data, this.$options.data());
			this.sessionData = keepSessionData;
			this.storeData = keepStoreData;
			this.init();
		},
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>